import React from 'react';
import { Document, Page, Text, View, StyleSheet, Font, PDFViewer } from '@react-pdf/renderer';

import NotoSansDevanagari from '../../../../fonts/NotoSansDevanagari-VariableFont_wdth,wght.ttf';

Font.register({
  family: 'NotoSansDevanagari',
  src: NotoSansDevanagari,
});

// Create professional styles
const styles = StyleSheet.create({
  page: {
    padding: '40pt 50pt',
    fontSize: 10,
    lineHeight: 1.5,
    fontFamily: 'NotoSansDevanagari',
    marginLeft: 10,
  },
  headerContainer: {
    marginBottom: 15,
    borderBottomWidth: 1,
    borderBottomColor: '#333',
    borderBottomStyle: 'solid',
    paddingBottom: 10,
  },
  header: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  subHeader: {
    textAlign: 'center',
    fontSize: 10,
    marginBottom: 3,
    color: '#555',
  },
  divider: {
    borderTopWidth: 1,
    borderTopColor: '#333',
    borderTopStyle: 'solid',
    marginVertical: 10,
  },
  schoolName: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 8,
    textTransform: 'uppercase',
  },
  officeOrder: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 15,
    textDecoration: 'underline',
    letterSpacing: 1,
  },
  contentText: {
    marginBottom: 8,
    textAlign: 'justify',
  },
  table: {
    width: '100%',
    marginBottom: 20,
    borderWidth: 1,
    borderColor: '#333',
    borderStyle: 'solid',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#333',
    borderBottomStyle: 'solid',
    minHeight: 24,
  },
  tableCol1: {
    width: '8%',
    padding: '4pt 5pt',
    borderRightWidth: 1,
    borderRightColor: '#333',
    borderRightStyle: 'solid',
  },
  tableCol2: {
    width: '62%',
    padding: '4pt 5pt',
    borderRightWidth: 1,
    borderRightColor: '#333',
    borderRightStyle: 'solid',
  },
  tableCol3: {
    width: '30%',
    padding: '4pt 5pt',
  },
  tableHeader: {
    backgroundColor: '#f0f0f0',
    fontWeight: 'bold',
  },
  nestedTable: {
    marginVertical: 5,
    borderWidth: 1,
    borderColor: '#999',
    borderStyle: 'solid',
  },
  nestedRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#999',
    borderBottomStyle: 'solid',
  },
  nestedHeaderRow: {
    backgroundColor: '#f5f5f5',
    fontWeight: 'bold',
  },
  nestedCell: {
    width: '33%',
    padding: '3pt 5pt',
    borderRightWidth: 1,
    borderRightColor: '#999',
    borderRightStyle: 'solid',
  },
  nestedLastCell: {
    width: '33%',
    padding: '3pt 5pt',
  },
  signatureContainer: {
    marginTop: 80,
    paddingTop: 15,
  },
  signatureLine: {
    width: '60%',
    marginTop: 30,
    borderTopWidth: 1,
    borderTopColor: '#333',
    borderTopStyle: 'solid',
    paddingTop: 5,
  },
  footer: {
    marginTop: 15,
    fontSize: 9,
    color: '#666',
  },
  sectionTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    marginTop: 15,
    marginBottom: 8,
    textAlign: 'center',
    textDecoration: 'underline',
  },
  noteText: {
    fontSize: 9,
    fontStyle: 'italic',
    color: '#666',
    marginTop: 5,
  },
  boldText: {
    fontWeight: 'bold',
  },
});
// Footer component (placed outside NewAppointment)
const Footer = ({ pageNumber, totalPages }) => (
  <View
    style={{
      position: 'absolute',
      bottom: 20,
      left: 50,
      right: 50,
      fontSize: 9,
      color: '#555',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingTop: 6,
      borderTopWidth: 0.5,
      borderTopColor: 'rgb(0,0,0)',
      borderTopStyle: 'solid',
    }}
  >
    <Text>himanshusalarycorner.in</Text>
    <Text>पृष्ठ {pageNumber} / {totalPages}</Text>
  </View>
);

const NewAppointment = ({ result }) => {
  function subtractOneDay(dateString) {
    const [day, month, year] = dateString.split('/').map(Number);
    const date = new Date(year, month - 1, day);
  
    // Subtract 1 day
    date.setDate(date.getDate() - 1);
  
    // Format back to dd/mm/yyyy
    const newDay = String(date.getDate()).padStart(2, '0');
    const newMonth = String(date.getMonth() + 1).padStart(2, '0');
    const newYear = date.getFullYear();
  
    return `${newDay}/${newMonth}/${newYear}`;
  }
  
  // Example usage:
  const adjustedDate = subtractOneDay(result.dateOfAppointment);

  return (
  <Document>
    <Page size="A4" style={styles.page}>
    <>
      {/* Header Section */}
      <View style={styles.headerContainer}>
        <Text style={styles.header}>
          दि. ०१/०१/२०१६ रोजी किंवा त्यानंतर नियुक्त झालेल्या कर्मचाऱ्याचे सुधारित वेतन संरचनेत
        </Text>
        <Text style={[styles.header, { marginBottom: 8 }]}>वेतन निश्चिती प्रपत्र</Text>

        <Text style={styles.subHeader}>
          शासन परिपत्रक क्रमांक:- वेपूर -२०१९/प्र.क्र.८/सेवा-९, दिनांक- २०फेब्रुवारी २०१९
        </Text>
        <Text style={styles.subHeader}>
          शालेय शिक्षण व क्रीडा विभाग शासन निर्णय क्रमांक:-वेतन -१२१९/प्र.क्र.१९/१९/टी एन टी-३, मुंबई-३२ दि. २२ फेब्रुवारी २०१९
        </Text>
      </View>

      {/* School and Order Details */}
      <Text style={styles.schoolName}>{result.officeName}</Text>
      <Text style={styles.officeOrder}>[कार्यालयीन आदेश]</Text>

      {/* Main Content */}
      <Text style={styles.contentText}>
        {result.employeeName}, हुद्दा: {result.designation} यांचा शिक्षण सेवक कालावधी दि. {adjustedDate} रोजी पूर्ण झाल्याने {result.educationOfficer} यांचे आदेश क्र. {result.adeshNumber} अन्वये त्यांची खालील प्रमाणे वेतन निश्चिती करण्यात येत आहे.
      </Text>

      {/* Salary Details Table */}
      <View style={styles.table}>
        {/* Table Header */}
        <View style={[styles.tableRow, styles.tableHeader]}>
          <Text style={styles.tableCol1}>क्र.</Text>
          <Text style={styles.tableCol2}>तपशील</Text>
          <Text style={styles.tableCol3}>माहिती</Text>
        </View>
        
        {/* Row 1 */}
        <View style={styles.tableRow}>
          <Text style={styles.tableCol1}>१</Text>
          <Text style={styles.tableCol2}>नियमित वेतनस्तरातील नियुक्ती दिनांक</Text>
          <Text style={styles.tableCol3}>{result.dateOfAppointment}</Text>
        </View>
        
        {/* Row 2 */}
        <View style={styles.tableRow}>
          <Text style={styles.tableCol1}>२</Text>
          <Text style={styles.tableCol2}>पदास लागू असलेला वेतनस्तर</Text>
          <Text style={styles.tableCol3}>{result.payScale}: {result.startPay}--{result.endPay}</Text>
        </View>
        
        {/* Row 3 */}
        <View style={styles.tableRow}>
          <Text style={styles.tableCol1}>३</Text>
          <Text style={styles.tableCol2}>
            नियुक्तीच्या वेळी निश्चित केलेले मूळ वेतन{"\n"}
            (पहा महाराष्ट्र शासन वित्त विभाग,शासन परिपत्रक क्रमांक: वेपूर-२०१९/प्र-क्र.८/सेवा-९ मधील नियम ८ अधिसूचनेनुसार)
          </Text>
          <Text style={styles.tableCol3}>{result.startPay}</Text>
        </View>
        
        {/* Row 4 */}
        <View style={styles.tableRow}>
          <Text style={styles.tableCol1}>४</Text>
          <Text style={styles.tableCol2}>पुढील वेतनवाढ दिनांक (सुधारित वेतन नियम ,२०१९ नियम क्र १० नुसार )</Text>
          <Text style={styles.tableCol3}>{result.nextIncrementDate}</Text>
        </View>
        
        {/* Row 5 - Increment Details */}
        <View style={styles.tableRow}>
          <Text style={styles.tableCol1}>५</Text>
          <View style={styles.tableCol2}>
            <Text style={styles.boldText}>पुढील वेतनवाढीचा तपशील</Text>
            
            <View style={styles.nestedTable}>
              {/* Header Row */}
              <View style={[styles.nestedRow, styles.nestedHeaderRow]}>
                <Text style={styles.nestedCell}>वेतन वाढीचा दिनांक</Text>
                <Text style={styles.nestedCell}>वेतन मॅट्रिक्समधील</Text>
                <Text style={styles.nestedLastCell}>अनुज्ञेय वेतन</Text>
              </View>

              {/* Data Rows */}
              {result.incrementDates.map((date, index) => (
                <View style={styles.nestedRow} key={index}>
                  <Text style={styles.nestedCell}>{date}</Text>
                  <Text style={styles.nestedCell}>{result.payScale}</Text>
                  <Text style={styles.nestedLastCell}>{result.basicPays[index]}</Text>
                </View>
              ))}
            </View>
          </View>
          <View style={styles.tableCol3}></View>
        </View>
      </View>

      {/* Other Information */}
      <Text style={[styles.contentText, styles.boldText]}>६. इतर अनुषंगिक माहिती : {result.remark || '___________________'}</Text>
      



      <Footer pageNumber={'१'} totalPages={'२'} />
      </>



      </Page>



      {/* Annexure Section */}
      <Page size="A4" style={styles.page}>
      <>
      <View style={{ marginTop: 20 }}>

      <View style={styles.headerContainer}>
        <Text style={styles.header}>
        महाराष्ट्र शासन राजपत्र असाधारण भाग चार -अ , जानेवारी ३०,२०१९ /माघ १०, शके १९४०
        </Text>
        <Text style={[styles.header, { marginBottom: 8 }]}>वेतन निश्चिती प्रपत्र</Text>

        <Text style={styles.subHeader}>
        ( शासन अधि सूचना , वि त्त वि भाग क्रमांक वेपूर २०१९ . प्र क्र १ /सेवा -९
        </Text>
        <Text style={styles.subHeader}>
        नांक ३० जानेवारी , २०१९ चे सहपत्र )
        </Text>
      </View>


        <Text style={styles.sectionTitle}>जोडपत्र चार</Text>
        <Text style={[styles.contentText, { textAlign: 'center' }]}>[पहा नियम ६ (२)(३)]</Text>
        <Text style={styles.sectionTitle}>वचन पत्र</Text>

        <Text style={styles.contentText}>
          मी, {result.employeeName}, {result.designation},{result.officeName} असे वचन देतो की , महाराष्ट्र नागरी सेवा (सुधारित वेतन ) नियम ,२०१९ मधील तरतुदींशी विसंगत वेतननिश्चितीच्या परिणामी किंवा पुढे वेतननिश्चिती मध्ये विसंगती आढळून आल्यामुळे मला अतिप्रदान झाल्याचे निदर्शनास आल्यास ते भविष्यात मला प्रदान करण्यात येणाऱ्या रकमेतून समायोजित करून किंवा इतर प्रकारे शासनास परत करीन.
        </Text>

        {/* Signature Section */}
        <View style={styles.signatureContainer}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <View>
              <Text>ठिकाण :  ________________</Text>
              <Text>दिनांक : ________________</Text>
            </View>
            <View style={styles.signatureLine}>
              <Text style={{ textAlign: 'center' }}>श्री. {result.employeeName}</Text>
              <Text style={{ textAlign: 'center' }}>पदनाम: {result.designation}</Text>
            </View>
          </View>
        </View>
      </View>
      <Footer pageNumber={'१'} totalPages={'२'} />
      </>

    </Page>
  </Document>
);
};

export default NewAppointment;